import React, { useState, useEffect } from "react";
import BaseLayout from "../components/BaseLayout/index";
import { makeStyles } from "@material-ui/core/styles";
import { Button, TextField } from "@material-ui/core";
import { WallpaperTwoTone } from "@material-ui/icons";
import { useWallet } from "../context/walletProvider";
import { mintToken, whitelistToken } from "../components/web3Wrapper";
import { useHistory } from "react-router-dom";
const useStyles = makeStyles(({ breakpoints, spacing }, theme) => ({
  root: {
    flexGrow: 1,
    //background: "#000714",
  },
  title: {
    fontSize: 14,
  },
}));
const Mint = () => {
  const classes = useStyles();
  const history = useHistory();
  const [tokenURI, setTokenURI] = useState();
  const [isMinted, setMinted] = useState(false);
  const [isWhitelisted, setWhitelisted] = useState(false);
  const wallet = useWallet();
  const handleWhitelist = async () => {
    if (isMinted) {
      wallet.setLoadingState(true);
      await whitelistToken(wallet.account);
      setWhitelisted(true);
      wallet.setLoadingState(false);
      history.push("/create");
    }
  };
  const handleMint = async () => {
    wallet.setLoadingState(true);
    await mintToken(tokenURI, wallet.account);
    setMinted(true);
    setTokenURI("");
    wallet.setLoadingState(false);
  };
  return (
    <BaseLayout className={classes.root} style={{ marginBottom: "10%" }}>
      {wallet.status == "connected" ? (
        <div className="mint-wrapper">
          <h3 style={{ color: "#E0E0E0" }}>Mint and Whitelist</h3>
          <TextField
            size="small"
            style={{
              width: "95%",
              backgroundColor: "#0E0E0E",
              borderRadius: "10px",
              height: "35px",
              margin: "10px 0",
            }}
            label="Image URL"
            variant="outlined"
            InputLabelProps={{ className: "text-label" }}
            InputProps={{ className: "input-field" }}
            value={tokenURI}
            onChange={(e) => {
              setTokenURI(e.target.value);
            }}
          />
          <Button
            style={{
              borderRadius: "30px",
              boxShadow: "0px 9px 14px rgba(255, 255, 255, 0.2)",
              fontSize: ".7rem",
              fontWeight: "bold",
              width: "100px",
              margin: "0 5px",
            }}
            variant="contained"
            size="large"
            onClick={handleMint}
          >
            Mint
          </Button>
          <Button
            style={{
              borderRadius: "30px",
              boxShadow: "0px 9px 14px rgba(255, 255, 255, 0.2)",
              fontSize: ".7rem",
              fontWeight: "bold",
              width: "100px",
              margin: "0 5px",
            }}
            variant="contained"
            size="large"
            onClick={handleWhitelist}
          >
            Whitelist
          </Button>
          {isMinted ? <div className="mint-message">Minted now Whitelist</div> : ""}
          {isWhitelisted ? <div className="mint-message">Whitelisted</div> : ""}
        </div>
      ) : (
        <div className="mint-wrapper">Connect Wallet to continue</div>
      )}
    </BaseLayout>
  );
};
export default Mint;
